import { useQuery, UseQueryOptions } from "@tanstack/react-query";
import { AmityProductAxios } from "@configs/api/AmityProductAxios";
import { createQueryFn } from "./utils";
import { LINE_MESSAGE_CHANNEL_ID } from "@configs";

const mappingKeys = {
  userIdentity: ["useridentity"] as const,
  getMappingStatus: (params: { channel: string }) =>
    [...mappingKeys.userIdentity, "status", params] as const,
};

export const useUserMappingStatus = (
  lineAccessToken: string,
  options?: UseQueryOptions<
    {
      isRegistered: boolean;
      actions?: {
        type: string;
        timestamp: string;
      }[];
    },
    {
      name: string;
      message: string;
      code: number;
      type: string;
    },
    {
      isRegistered: boolean;
      actions?: {
        type: string;
        timestamp: string;
      }[];
    },
    ReturnType<typeof mappingKeys.getMappingStatus>
  >
) => {
  return useQuery({
    queryKey: mappingKeys.getMappingStatus({
      channel: LINE_MESSAGE_CHANNEL_ID,
    }),
    queryFn: ({ queryKey }) => {
      return createQueryFn(AmityProductAxios, queryKey, {
        headers: {
          "x-platform-token": lineAccessToken,
          "Content-Type": "application/json",
        },
      }).then((res) => res as any);
    },
    ...options,
  });
};
